<template>
  <div>
    <div class="cat-magazine-slide container-fluid">
      <div class="cat-magazine-slide__intro vertical">
        <h3 style="margin-top: 40px">
          <img
            src="@/assets/img/icon__book-open.svg"
            style="margin-bottom: 3px;"
          />メルマガ紹介
        </h3>
        <!-- <div
          class="magazineDescription"
          v-html="item.magazineDescription"
        ></div> -->
        <div
          class="magazineDescription"
          v-if="item.customMagazineDescription !== ''"
        >
          <p v-html="item.customMagazineDescription"></p>
        </div>
        <div class="magazineDescription" v-else>
          <p v-html="magazineDescription"></p>
        </div>
      </div>
      <div class="cat-magazine-slide__golden-plate">
        <div class="row">
          <div class="col-3" style="padding-right: 0; text-align: right">
            <img
              style="max-width: 85px; max-height: 90px;"
              :src="item.coverImage"
              alt=""
            />
          </div>
          <div class="col-6" style="padding-right: 0">
            <img
              class="cat-magazine-slide__golden-plate__logo-simplified"
              src="@/assets/img/award-logo__simplified.svg"
              alt=""
            />
            <div
              class="cat-magazine-slide__golden-plate__title resize-to-fit-36 row align-items-center"
            >
              <div :style="categoryRankStyle" ref="categoryRank">
                {{ item.categoryName }}{{ item.rank }}位
              </div>
            </div>
          </div>
          <div class="col-3 d-flex cat-magazine-slide__golden-plate__rank">
            <img
              style="height: 90px"
              src="@/assets/img/award-logo__black-trophy.svg"
              alt=""
            />
          </div>
        </div>
        <div
          class="cat-magazine-slide__golden-plate__magazine-title resize-to-fit-36"
        >
          <div :style="magazineTitleStyle" ref="magazineTitle">
            {{ item.magazineTitle }}
          </div>
        </div>
        <div class="cat-magazine-slide__golden-plate__magazine-info">
          <div>
            <span v-if="item.free === 'FALSE'">
              <b>¥</b> {{ item.basicPriceWithTax }}/月(税込)
            </span>
            <span v-else>無料</span>
            <span
              ><img
                src="@/assets/img/icon__cycle-black.svg"
                style="margin-right: 3px; margin-left: 5px"
              />{{ item.cycleType }}</span
            >
          </div>
        </div>
      </div>
      <div
        v-if="item.authorComment"
        class="cat-magazine-slide__comment vertical"
      >
        <h3><img src="@/assets/img/icon__comment.svg" />受賞者コメント</h3>
        <div class="magazineDescription" v-html="item.authorComment"></div>
      </div>
      <div
        v-else-if="item.userComment"
        class="cat-magazine-slide__comment vertical"
      >
        <h3><img src="@/assets/img/icon__comment.svg" />読者コメント</h3>
        <div class="magazineDescription" v-html="item.userComment"></div>
      </div>

      <!-- if comments exeits -> narrow button -->
      <div
        v-if="item.authorComment || item.userComment"
        class="cat-magazine-slide__register-share"
      >
        <div class="row">
          <div class="col-8" style="padding: 0">
            <div v-if="item.free === 'FALSE'">
              <div v-if="item.firstMonthPayFlag === '0'">
                <!-- if comment and pay -->
                <form
                  name="registForm_0"
                  :action="
                    'https://mypage.mag2.com/ui/subscribe/' + item.magazineId
                  "
                  method="get"
                >
                  <input
                    type="hidden"
                    name="reg"
                    value="mag2award2020"
                    class="hidden blockCenter"
                  />
                  <button
                    type="submit"
                    name="registBtn"
                    class="btn btn-block btn-orange"
                  >
                    登録へすすむ
                  </button>
                </form>
              </div>

              <div v-else>
                <!--有料ボタン(初月有料)-->
                <div class="regbtn-wrap top10">
                  <form
                    name="registForm_0"
                    action="https://mypage.mag2.com/subscribe/SubscribePayMagazine2.do"
                    method="get"
                  >
                    <input
                      type="hidden"
                      name="reg"
                      value="mag2award2020"
                      class="hidden"
                    />
                    <input
                      :value="item.magazineId"
                      name="magazineId"
                      type="hidden"
                      class="hidden"
                    />
                    <button
                      type="submit"
                      name="registBtn"
                      class="btn btn-block btn-orange"
                    >
                      登録へすすむ
                    </button>
                  </form>
                </div>
                <!--/有料ボタン(初月有料)-->
              </div>
            </div>
            <div v-else>
              <!--無料ボタン-->
              <div class="v-if-Free">
                <div class="mag2019-free__no-comment blockCenter">
                  <form
                    action="https://regist.mag2.com/reader/Magrdadd"
                    method="post"
                    class="reg"
                  >
                    <input
                      type="hidden"
                      name="reg"
                      value="mag2award2020"
                      class="hidden"
                    /><input
                      :value="item.magazineId"
                      name="magid"
                      type="hidden"
                      class="hidden"
                    />
                    <ul class="ClearFix">
                      <li class="flex_widht70">
                        <p class="supple">
                          無料メルマガ<a
                            href="https://www.mag2.com/terms/reader.html"
                            target="_blank"
                            >登録規約</a
                          >に同意して
                        </p>
                        <input
                          type="email"
                          name="rdemail"
                          class="rdemail rdmail-under freeResisterInput"
                          placeholder="メールアドレスを入力"
                        />
                      </li>
                      <li class="flex_widht30">
                        <button
                          type="submit"
                          name="registBtn"
                          class="btn btn-orange btn-block rdmail-reg rdmail-under freeResisterButton"
                        >
                          無料で<br />登録
                        </button>
                      </li>
                    </ul>
                  </form>
                </div>
              </div>
            </div>
            <!--/無料ボタン-->
          </div>
          <div class="col-4" style="padding: 0 0 0 5px">
            <div class="share-number-box">{{ shareCounts }}件</div>
            <!-- <button type="button" class="btn btn-primary btn-sns btn-block">
              SNSでシェア
            </button> -->

            <!--SNS-->
            <span class="sns-btnbox clearfix">
              <ul class="sns-drop">
                <li>
                  <ul class="sns-btn">
                    <li class="row d-flex">
                      <a
                        :href="
                          'https://www.facebook.com/sharer/sharer.php?u=https://www.mag2.com/events/mag2year/2020/category/' +
                            item.categoryId +
                            '.html%23' +
                            item.magazineId
                        "
                        onclick="window.open(this.href, 'window ','width = 550, height = 450, personalbar = 0, toolbar = 0, scrollbars = 1, resizable = 1 '); return false;"
                      >
                        <img
                          class="hero_img"
                          src="https://www.mag2.com/events/mag2year/2019/images/Facebook.png"
                        />
                      </a>
                      <a
                        :href="
                          'https://twitter.com/intent/tweet?url=https://www.mag2.com/events/mag2year/2020/category/' +
                            item.categoryId +
                            '.html%23' +
                            item.magazineId +
                            '&text=「まぐまぐ大賞2020」受賞メルマガ - ' +
                            item.categoryName +
                            ' - ' +
                            item.magazineTitle +
                            '&hashtags=まぐまぐ大賞2020'
                        "
                        onclick="window.open(encodeURI(decodeURI(this.href)), ' tweetwindow ', ' width=550, height=450, personalbar=0, toolbar=0, scrollbars=1, resizable=1 ' ); return false;'"
                      >
                        <img
                          class="hero_img"
                          src="https://www.mag2.com/events/mag2year/2019/images/Twitter.png"
                        />
                      </a>
                      <!-- <a
                      class="col-3"
                        :href="
                          'https://b.hatena.ne.jp/amode=confirm&url=https://www.mag2.com/events/mag2year/2020/category/' +
                          item.categoryId +
                          '.html&title=' +
                          item.magazineTitle +
                          ' - まぐまぐ大賞2020結果発表ページ'
                        "
                        target="_blank"
                      >
                        <img
                          class="hero_img"
                          src="https://www.mag2.com/events/mag2year/2019/images/Hatebu.png"
                        />
                      </a> -->
                      <a
                        :href="
                          'https://social-plugins.line.me/lineit/share?url=https://www.mag2.com/events/mag2year/2020/category/' +
                            item.categoryId +
                            '.html%23' +
                            item.magazineId
                        "
                      >
                        <img
                          style="margin-right: 0"
                          class="hero_img"
                          src="https://www.mag2.com/events/mag2year/2019/images/Line.png"
                        />
                      </a>
                    </li>
                  </ul>
                  <span class="btn btn-primary btn-sns btn-block" v-on:mouseover="shareButtonOn" v-on:mouseleave="shareButtonLeave"
                    >シェアする
                    <!-- <i class="fas fa-share-alt-square"></i> -->
                  </span>
                </li>
              </ul>
            </span>
            <!--SNS-->
          </div>
        </div>
      </div>

      <!-- no comments -> wide buttons -->
      <div
        v-else
        class="cat-magazine-slide__register-share__buttons-only cat-magazine-slide__register-share"
      >
        <div class="" style="padding: 0">
          <div v-if="item.free === 'FALSE'">
            <div v-if="item.firstMonthPayFlag === '0'">
              <form
                name="registForm_0"
                :action="
                  'https://mypage.mag2.com/ui/subscribe/' + item.magazineId
                "
                method="get"
              >
                <input
                  type="hidden"
                  name="reg"
                  value="mag2award2020"
                  class="hidden blockCenter"
                />
                <button
                  type="submit"
                  name="registBtn"
                  class="btn btn-block btn-orange"
                >
                  登録へすすむ
                </button>
              </form>
            </div>

            <div v-else>
              <!--有料ボタン(初月有料)-->
              <div class="regbtn-wrap top10">
                <form
                  name="registForm_0"
                  action="https://mypage.mag2.com/subscribe/SubscribePayMagazine2.do"
                  method="get"
                >
                  <input
                    type="hidden"
                    name="reg"
                    value="mag2award2020"
                    class="hidden"
                  />
                  <input
                    :value="item.magazineId"
                    name="magazineId"
                    type="hidden"
                    class="hidden"
                  />
                  <button
                    type="submit"
                    name="registBtn"
                    class="btn btn-block btn-orange"
                  >
                    登録へすすむ
                  </button>
                </form>
              </div>
              <!--/有料ボタン(初月有料)-->
            </div>
          </div>
          <div v-else>
            <!--無料ボタン-->
            <div class="v-if-Free">
              <div class="mag2019-free blockCenter">
                <form
                  action="https://regist.mag2.com/reader/Magrdadd"
                  method="post"
                  class="reg"
                >
                  <input
                    type="hidden"
                    name="reg"
                    value="mag2award2020"
                    class="hidden"
                  /><input
                    :value="item.magazineId"
                    name="magid"
                    type="hidden"
                    class="hidden"
                  />
                  <ul class="ClearFix">
                    <li class="flex_widht70">
                      <p class="supple">
                        無料メルマガ<a
                          href="https://www.mag2.com/terms/reader.html"
                          target="_blank"
                          >登録規約</a
                        >に同意して
                      </p>
                      <input
                        type="email"
                        name="rdemail"
                        class="rdemail rdmail-under freeResisterInput"
                        placeholder="メールアドレスを入力"
                      />
                    </li>
                    <li class="flex_widht30">
                      <button
                        type="submit"
                        name="registBtn"
                        class="btn btn-orange btn-block rdmail-reg rdmail-under freeResisterButton"
                      >
                        無料で登録
                      </button>
                    </li>
                  </ul>
                </form>
              </div>
            </div>
          </div>
          <!--/無料ボタン-->
        </div>
        <div class="col-8 mx-auto mt-3" style="padding: 0 0 0 5px">
          <div class="share-number-box">{{ shareCounts }}件</div>
          <!-- <button type="button" class="btn btn-primary btn-sns btn-block">
              SNSでシェア
            </button> -->

          <!--SNS-->
          <span class="sns-btnbox clearfix">
            <ul class="sns-drop">
              <li>
                <ul class="sns-btn">
                  <li class="row d-flex">
                    <a
                      :href="
                          'https://www.facebook.com/sharer/sharer.php?u=https://www.mag2.com/events/mag2year/2020/category/' +
                            item.categoryId +
                            '.html%23' +
                            item.magazineId
                      "
                      onclick="window.open(this.href, 'window ','width = 550, height = 450, personalbar = 0, toolbar = 0, scrollbars = 1, resizable = 1 '); return false;"
                    >
                      <img
                        class="hero_img"
                        src="https://www.mag2.com/events/mag2year/2019/images/Facebook.png"
                      />
                    </a>
                    <a
                      :href="
                          'https://twitter.com/intent/tweet?url=https://www.mag2.com/events/mag2year/2020/category/' +
                            item.categoryId +
                            '.html%23' +
                            item.magazineId +
                            '&text=「まぐまぐ大賞2020」受賞メルマガ - ' +
                            item.categoryName +
                            ' - ' +
                            item.magazineTitle +
                            '&hashtags=まぐまぐ大賞2020'
                      "
                      onclick="window.open(encodeURI(decodeURI(this.href)), ' tweetwindow ', ' width=550, height=450, personalbar=0, toolbar=0, scrollbars=1, resizable=1 ' ); return false;'"
                    >
                      <img
                        class="hero_img"
                        src="https://www.mag2.com/events/mag2year/2019/images/Twitter.png"
                      />
                    </a>
                    <!-- <a
                      class="col-3"
                        :href="
                          'https://b.hatena.ne.jp/amode=confirm&url=https://www.mag2.com/events/mag2year/2020/category/' +
                          item.categoryId +
                          '.html&title=' +
                          item.magazineTitle +
                          ' - まぐまぐ大賞2020結果発表ページ'
                        "
                        target="_blank"
                      >
                        <img
                          class="hero_img"
                          src="https://www.mag2.com/events/mag2year/2019/images/Hatebu.png"
                        />
                      </a> -->
                    <a
                      :href="
                        'https://social-plugins.line.me/lineit/share?url=https://www.mag2.com/events/mag2year/2020/category/' +
                          item.categoryId +
                          '.html'
                      "
                    >
                      <img
                        style="margin-right: 0"
                        class="hero_img"
                        src="https://www.mag2.com/events/mag2year/2019/images/Line.png"
                      />
                    </a>
                  </li>
                </ul>
                <span class="btn btn-primary btn-sns btn-block" v-on:mouseover="shareButtonOn" v-on:mouseleave="shareButtonLeave"
                  >シェアする
                  <!-- <i class="fas fa-share-alt-square"></i> -->
                </span>
              </li>
            </ul>
          </span>
          <!--SNS-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      shareCounts: 0,
      categoryRankFontSize: 40,
      magazineTitleFontSize: 40,
      magazineDescription: ''
    }
  },
  mounted() {
    this.fitCategoryRankFont()
    this.fitMagazineTitleFont()
    this.updateShareCounts()

    this.magazineDescription = this.item.magazineDescription.replace("＜", '︿')
    this.magazineDescription = this.magazineDescription.replace("＞", '﹀')
  },
  computed: {
    categoryRankStyle() {
      return {
        'font-size': `${this.categoryRankFontSize}px`
      }
    },
    magazineTitleStyle() {
      return {
        'font-size': `${this.magazineTitleFontSize}px`
      }
    }
  },
  methods: {
    fitCategoryRankFont() {
      if (this.$refs.categoryRank.clientHeight >= 40) {
        this.categoryRankFontSize -= 1
        this.$nextTick(() => {
          this.fitCategoryRankFont()
        })
      }
    },
    fitMagazineTitleFont() {
      if (this.$refs.magazineTitle.clientHeight >= 40) {
        this.magazineTitleFontSize -= 1
        this.$nextTick(() => {
          this.fitMagazineTitleFont()
        })
      }
    },
    updateShareCounts() {
      /*
      var url =
        'https://www.mag2.com/events/mag2year/2019/category/' +
        this.item.categoryId +
        '.html'
      */
      // 本番用
      var url =
        'https://www.mag2.com/events/mag2year/2020/category/' +
        this.item.categoryId +
        '.html#' +
        this.item.magazineId

      axios
        .get('https://jsoon.digitiminimi.com/twitter/count.json?url=' + url)
        .then((response) => {
          this.shareCounts = response.data.count + response.data.likes
        })
    },
    shareButtonOn(e) {
      e.target.parentNode.parentNode.parentNode.previousSibling.style.opacity = 0;
    },
    shareButtonLeave(e) {
      e.target.parentNode.parentNode.parentNode.previousSibling.style.opacity = 1;
    }
  }
}
</script>

<style scoped>
.cat-magazine-slide .magazineDescription p {
  margin: 0;
}

.sns-btnbox {
  text-align: right;
  clear: both;
  position: relative;
  align-self: center;
  margin-top: -4px;
  margin-left: auto;
  z-index: 10;
}

.sns-drop {
  *zoom: 1;
  list-style-type: none;
  margin: 0 auto;
  padding: 0;
  float: left;
  font-size: 16px;
  width: 100%;
}

.sns-drop .sns-text {
  cursor: pointer;
  transition: all 0.3s;
  font-size: 12px;
  color: #d4af37;
  margin-right: 5px;
}

.sns-drop .sns-text i {
  margin-left: 5px;
}

.sns-drop:before,
.sns-drop:after {
  content: '';
  display: table;
}

.sns-drop li {
  position: relative;
  margin: 0 !important;
  padding: 0;
  text-align: right;
  line-height: 1.3;
  /* min-width: 130px; */
}

.sns-drop li .sns-btn {
  list-style: none;
  position: absolute;
  left: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
  top: 30%;
  visibility: hidden;
  transition: 0.5s;
}

.sns-drop li .sns-btn li {
  /*  background: #1b1b1b; */
  /*  box-shadow:0 0 3px #000;*/
  text-align: center;
}

.sns-drop li .sns-btn li a {
  padding: 5px 0;
  text-align: left;
  display: inline-block;
}

.sns-btnbox .sns-btn li a:hover {
  opacity: 0.6;
  transition: all 0.3s;
}

.sns-drop li .sns-btn li img {
  width: 25px;
  margin-right: 4px;
  transition: all 0.3s;
}

.sns-drop li :hover {
}

.sns-drop li:hover ul {
  top: -33px;
  visibility: visible;
  opacity: 1;
}

/* magazine slide */
.cat-magazine-slide__intro {
  /* height: calc(50vh - 28.125vw); */
  /* height: calc(50vh - 35vw); */
  height: calc(var(--vh) * 50 - 35vw);
  margin: 15px 0;
  width: 100%;
  overflow-x: scroll;
  font-size: 0.9em;
}

.cat-magazine-slide h3 {
  padding-left: 8px;
  /* padding-top: 35px; */
  margin-right: 0;
  font-size: 16px;
  border-left: 0.5px solid #222;
  font-family: 游明朝, 'Yu Mincho', YuMincho, 'Hiragino Mincho ProN',
    'Hiragino Mincho Pro', HGS明朝E, メイリオ, Meiryo, serif;
  font-weight: 800;
}

.cat-magazine-slide__intro h3 img {
  margin: 0;
}

.cat-magazine-slide__intro img {
  max-width: 70px;
  object-fit: cover;
  float: left;
  margin: 0 0 10px 10px;
}

.cat-magazine-slide__golden-plate {
  width: 100vw;
  height: calc(100vw * 0.5625);
  background-color: #d4af37;
  margin: 0 -15px;
  padding: 15px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  border: 10px solid;
  border-style: solid none none none;
}

.cat-magazine-slide__golden-plate__title {
  width: 100%;
  font-size: 8vw;
  text-align: center;
  font-family: 游明朝, 'Yu Mincho', YuMincho, 'Hiragino Mincho ProN',
    'Hiragino Mincho Pro', HGS明朝E, メイリオ, Meiryo, serif;
  font-weight: 800;
  position: absolute;
  bottom: 0;
  height: 40px;
  left: 48%;
  transform: translateX(-31%);
}

.cat-magazine-slide__golden-plate__title div {
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.cat-magazine-slide__golden-plate__logo-simplified {
  height: 45px;
  left: 56%;
  position: absolute;
  transform: translateX(-50%);
}

.cat-magazine-slide__golden-plate__rank-text {
  font-size: 7vw;
  right: 15px;
}

.cat-magazine-slide__golden-plate__magazine-title {
  font-size: 5vw;
  font-family: 游明朝, 'Yu Mincho', YuMincho, 'Hiragino Mincho ProN',
    'Hiragino Mincho Pro', HGS明朝E, メイリオ, Meiryo, serif;
  padding: 5px 0;
  border: 0.5px solid #222;
  border-style: solid none solid none;
  text-align: center;
  margin: 5px 0;
}

.cat-magazine-slide__golden-plate__magazine-info {
  text-align: right;
  font-size: 12px;
}

.cat-magazine-slide__comment {
  position: absolute;
  /* top: calc(50vh + 28.125vw); */
  height: calc(var(--vh) * 50 - 28.125vw - 65px);
  width: calc(100vw - 30px);
  top: calc(50 * var(--vh) + 30vw + 5px);
  left: 15px;
  overflow-x: scroll;
  font-size: 0.9em;
}

.cat-magazine-slide__comment h3 img {
  width: 16px;
  margin-left: -5px;
  margin-bottom: 5px;
}

.cat-magazine-slide__register-share {
  position: absolute;
  width: calc(100vw - 30px);
  padding: 0 15px;
  bottom: 0;
  height: 45px;
}

.cat-magazine-slide__register-share__buttons-only {
  position: absolute;
  width: calc(100vw - 30px);
  /* height: calc(50 * var(--vh) - 28.125vw - 15px); */
  height: 100px;
  bottom: calc(0.5 * ((50 * var(--vh)) - 40vw));
  /* bottom: 0; */
}

/* header */
.cat-header {
  /* max-width: 1200px; */
  font-family: 游明朝, 'Yu Mincho', YuMincho, 'Hiragino Mincho ProN',
    'Hiragino Mincho Pro', HGS明朝E, メイリオ, Meiryo, serif;
  margin: 40px auto;
}
.cat-header img {
  width: 100%;
}
.cat-header__award-title {
  border-style: solid none solid none;
  border-width: 0.5px;
  border-color: #222;
  position: relative;
}

.cat-header__award-title h2 {
  /* font-size: 8vw; */
  /* font-size: max(30px, 8vw); */
  font-size: min(max(50px, 8vw), 100px);
  width: fit-content;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 800;
}

.cat-header__introduction {
  margin-top: 10px;
}

/* orange button */
.btn-orange {
  background-color: #ff8c1a;
  color: #fff;
  margin: 0;
  height: 40px;
  font-size: 700;
}

.share-number-box {
  background: #fff;
  border: 0.5px solid #777;
  font-size: 10px;
  position: relative;
  box-sizing: border-box;

  border-radius: 5px;
  text-align: center;

  transition: all 0.5s;
}

.share-number-box:before {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  margin-left: -4px;
  border: 4px solid transparent;
  border-top: 4px solid #fff;
  z-index: 2;
}

.share-number-box:after {
  content: '';
  position: absolute;
  bottom: -9px;
  left: 50%;
  margin-left: -4px;
  border: 4px solid transparent;
  border-top: 4px solid #777;
  z-index: 1;
}

.btn-sns {
  font-size: 12px;
  padding: 0;
  margin-top: 3px;
}

.sp-only {
  display: none;
}

.pc-only {
  display: block;
}

@media screen and (max-width: 500px) {
  /* width */
  ::-webkit-scrollbar {
    -webkit-appearance: none !important;
    -webkit-overflow-scrolling: auto !important;
  }

  ::-webkit-scrollbar:horizontal {
    height: 5px !important;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    /* box-shadow: inset 0 0 5px #777; */
    border-radius: 5px !important;
    /* border: 0.3ex solid #e0e0e0; */
    background-color: #fff !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #777 !important;
    border-radius: 5px !important;
  }

  .sp-only {
    display: block;
  }

  .pc-only {
    display: none;
  }

  .cat-header {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}

@media screen and (max-height: 600px) {
  .marquee-sp {
    display: none;
  }
}

@media screen and (max-width: 1000px) {
  .cat-header__award-title {
    border-style: none none solid none;
    height: 80px;
  }

  .cat-header__award-illustration {
    width: 70%;
    margin: 5px auto;
  }

  .cat-header__award-illustration img {
    height: 20vh;
  }
}

/* marquee css */
.marquee {
  position: relative;
  overflow: hidden;
  --offset: 20vw;
  --move-initial: calc(-35% + var(--offset));
  --move-final: calc(-45% + var(--offset));

  background: #222;
  color: #d4af37;
  width: 100vw;
  margin: 0 -15px;
  height: 60px;
}

.marquee__inner {
  width: fit-content;
  display: flex;
  position: relative;
  transform: translate3d(var(--move-initial), 0, 0);
  animation: marquee 5s linear infinite;
  animation-play-state: running;

  width: 5000px;
  height: 50px;
}

.marquee span {
  font-size: 24px;
  /* padding: 0 2vw; */
  margin-top: 10px;
  border: solid 0.5px #d4af37;
}

.marquee-sp {
  /* position: absolute;
        bottom: 10px; */
}

@keyframes marquee {
  0% {
    transform: translate3d(var(--move-initial), 0, 0);
  }

  100% {
    transform: translate3d(var(--move-final), 0, 0);
  }
}

.mag2019-free__no-comment {
  margin-top: 4px;
}

.mag2019-free__no-comment ul {
  list-style: none;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
  justify-content: space-between;
  margin-bottom: 0;
  /* max-width: 490px; */
}
.mag2019-free__no-comment ul li {
  text-align: center;
  align-self: flex-end;
  margin-right: 5px;
}
.mag2019-free__no-comment ul li.flex_widht70 {
  width: calc(70% - 5px);
}
.mag2019-free__no-comment ul li.flex_widht30 {
  width: calc(30% - 5px);
}
.mag2019-free__no-comment .supple {
  font-size: 10px;
  margin: 0;
  float: left;
  color: #777;

  position: absolute;
  top: -9px;
}
.mag2019-free__no-comment button {
  font-size: 10px;
  line-height: 1.2;
}

.mag2019-free ul {
  list-style: none;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  flex-wrap: wrap;
  margin: 20px auto;
  align-items: center;
  padding: 0;
  justify-content: space-between;
  max-width: 490px;
}
.mag2019-free ul li {
  text-align: center;
  align-self: flex-end;
  margin-right: 5px;
}
.mag2019-free ul li.flex_widht70 {
  width: calc(70% - 5px);
}
.mag2019-free ul li.flex_widht30 {
  width: calc(30% - 5px);
}
.mag2019-free .supple {
  font-size: 12px;
  margin: 0;
  float: left;
  color: #777;
}

form input[type='text'],
form input[type='email'],
form input[type='password'],
form select,
form textarea {
  position: relative;
  -webkit-appearance: none;
  display: block;
  border: 0;
  outline: 0;
  background: #fff;
  background: rgba(255, 255, 255, 0.75);
  width: 100%;
  padding: 0.1em 0.1em;
  border: solid 1px rgba(0, 0, 0, 0.15);
  -moz-transition: all 0.35s ease-in-out;
  -webkit-transition: all 0.35s ease-in-out;
  -ms-transition: all 0.35s ease-in-out;
  transition: all 0.35s ease-in-out;
}
input.rdemail.rdmail-under {
  font-size: 12px;
  position: relative;
  top: 0px;
  border-radius: 3px;
  line-height: 2.2;
  padding: 4px;
}
.freeResisterButton {
  height: 36px;
  margin: 0 !important;
  padding: 0 !important;
}
.freeResisterInput {
}
</style>
